import { Page } from '@/core/architecture'

import { ConsoleOfficialInformationsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleOfficialInformations Page
 * Implemented as a practical sample.
 */
export const ConsoleOfficialInformations: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleOfficialInformationsTemplate state={state} {...actions} />
}
